import { Typography } from '@mui/material';
import type { Event, PaginatedList, Person } from 'core';
import type { FC } from 'react';
import { ErrorView } from '../../components/common/error.js';
import { ListPendingView } from '../../components/common/list-pending.js';
import type { UseAxiosResult } from '../../hooks/use-axios.js';
import { ListItemsView } from '../event-list/list-items.js';
import { NotFoundPage } from '../not-found/page.js';

interface Props {
  events: UseAxiosResult<PaginatedList<Event.WithCourses> | undefined>;
  person: Person.Type;
}

export const GroupEventsView: FC<Props> = ({
  events: { data, error, loading },
  person,
}) =>
  loading ? (
    <ListPendingView />
  ) : error ? (
    <ErrorView error={error} />
  ) : !data ? (
    <NotFoundPage />
  ) : !data.items.length ? (
    <Typography variant="body2" color="text.secondary" fontStyle="italic">
      There are no events for this group yet
    </Typography>
  ) : (
    <ListItemsView data={data} person={person} showGroup={false} />
  );
